import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import Heading from '../../components/Common/Heading';
import Guide from '../../components/Common/Guide';
import SubmitButton from '../../components/Common/SubmitButton';
import { resetPassword } from './services/password.service';

const ResetPassword = () => {
  const { email, token } = useParams();
  const navigate = useNavigate();
  const [loader, setLoader] = useState<boolean>(false);
  const [newPassword, setNewPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewPassword(e.target.value);
  };
  const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await resetPassword(email!, token!, newPassword, confirmPassword, setLoader, navigate);
  };

  return (
    <div className="App">
      <NavigationBar />
      <div className="bg-storytan p-4 mx-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-screen">
          <div className=" flex items-center align-end mb-4">
            <Heading title="Reset Password" />
            <div>
              <Guide />
            </div>
          </div>
          <form
            id="form-reset-password"
            name="form-reset-password"
            className="mt-8 text-start"
            onSubmit={handleSubmit}
          >
            <div className="relative mt-4">
              <input
                type={showNewPassword ? 'text' : 'password'}
                name="newPassword"
                value={newPassword}
                onChange={handlePasswordChange}
                placeholder="New Password"
                className="p-2 w-full rounded-md pr-10"
                required
              />
              <span
                className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                <FontAwesomeIcon
                  icon={showNewPassword ? faEye : faEyeSlash}
                  className="text-gray-500 hover:text-gray-700"
                />
              </span>
            </div>
            <div className="relative mt-4">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                name="confirmPassword"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                placeholder="Confirm Password"
                className="p-2 w-full rounded-md pr-10"
                required
              />
              <span
                className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                <FontAwesomeIcon
                  icon={showConfirmPassword ? faEye : faEyeSlash}
                  className="text-gray-500 hover:text-gray-700"
                />
              </span>
            </div>
            {' '}
            <SubmitButton type="submit" title="Reset Password" loader={loader} />
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
